'use client';

import Link from 'next/link';
import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

import { AI_TOOLKIT_CATEGORIES, AiToolkitCategory } from '../../_context/types';

export interface ToastTitleProps {
    category: AiToolkitCategory;
    status: 'inProgress' | 'success' | 'error';
    href: string;
}

const categoryToTitle = {
    [AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION]: 'video',
    [AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION]: 'image',
    [AI_TOOLKIT_CATEGORIES.VOICEOVER]: 'voiceover',
    [AI_TOOLKIT_CATEGORIES.VIDEO_EDIT]: 'video',
};

const categoryToToolkitName = {
    [AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION]: 'Video Generator',
    [AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION]: 'Image Generator',
    [AI_TOOLKIT_CATEGORIES.VOICEOVER]: 'Voiceover Generator',
    [AI_TOOLKIT_CATEGORIES.VIDEO_EDIT]: 'Video Editor',
};

export const ToastTitle = ({
    category = AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION,
    status = 'inProgress',
    href = '/ai/video-generation',
}: ToastTitleProps): JSX.Element => {
    // TODO: Adjust copy as necessary when we have other toast notifications.

    const inProgressText = (
        <Text fontWeight="regular">
            We&apos;re generating your {categoryToTitle[category]}, click&nbsp;
            <Text asChild fontWeight="bold" className="underline">
                <Link href={href}>here</Link>
            </Text>
            &nbsp;to check the status. This may take a few minutes &ndash; we&apos;ll notify you when it&apos;s ready.
        </Text>
    );

    const successText = (
        <Text fontWeight="regular">
            Your {categoryToTitle[category]} is ready! Click&nbsp;
            <Text asChild fontWeight="bold" className="underline">
                <Link href={href}>here</Link>
            </Text>
            &nbsp;to view it.
        </Text>
    );

    const errorText = (
        <Text fontWeight="regular">
            Something went wrong while generating your {categoryToTitle[category]}. Please check&nbsp;
            <Text asChild fontWeight="bold" className="underline">
                <Link href={href}>{categoryToToolkitName[category]}</Link>
            </Text>
            &nbsp;and try again.
        </Text>
    );

    return status === 'inProgress' ? inProgressText : status === 'success' ? successText : errorText;
};
